import { usePermissionsRepository } from '@Hooks/useRepository';
import { type EntityInformation } from '@Model';
import { EntityConflictRepository } from '@Repositories/Permissions';
import { type IIdWithDisplay } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export function useCheckIsEntityNotInUse() {
    const references = usePermissionsRepository(EntityConflictRepository);

    const { mutateAsync: checkIsNotInUseMutation, isPending } = useMutation({
        mutationFn: (entity: EntityInformation) => references.checkIsEntityNotInUse(entity),
    });

    const checkIsNotInUse = useCallback(
        (obj: IIdWithDisplay, apiResourceType: string) => {
            const entity: EntityInformation = {
                type: apiResourceType,
                id: obj.id,
                display_string: obj.display_string,
            };
            return checkIsNotInUseMutation(entity);
        },
        [checkIsNotInUseMutation],
    );

    return {
        checkIsNotInUse,
        isCheckNotInUsePending: isPending,
    };
}
